
import { LockDec, ValidateDec } from "@/decorators";
import { TSX, Component, Prop, Vue, Watch } from 'vue-facing-decorator'

interface Props {
  data: any
}

@Component({})
export default class extends TSX<Props>()(Vue) implements Props {
  @Prop({})
  data: any;

  submitLoading = false;

  postData = {
    /** 0 减少、1 增加 */
    type: 1,
    amount: "",
    message: "",
  }

  validateAmount(v) {
    if (!v) throw '请输入调整金额'
    if (Number(v) < 0.01) throw '调整金额必须大于 0'
    if (Number(v) > 9999999) throw '调整金额超出范围'
  }

  @ValidateDec("form")
  @LockDec("submitLoading")
  async submit() {
    await this.$postNotify("/manager/user/adjust-amount", {
      id: this.data.id,
      type: this.postData.type,
      amount: Number(this.postData.amount),
      message: this.postData.message,
    })
    this.$emit("resolve")
  }

  close() {
    this.$emit("reject", { msg: '取消' })
  }
}
